module.exports = __webpack_public_path__ + "static/media/gavel.e0256fff.svg";